import { z } from 'zod'
// OPTIONS preflight routes have empty bodies; schema is unused for binary/empty responses.
export const uploadsBindingOptionsResponseSchema = z.record(z.unknown())
export type UploadsBindingOptionsResponse = z.infer<typeof uploadsBindingOptionsResponseSchema>
